import type { MOTOBOY_FORM_SCHEMA } from './constants';
import type { InferType } from '@/_config/lib/yup';

export type DeliverymanFormType = InferType<typeof MOTOBOY_FORM_SCHEMA>;

export enum ENUM_FILE_NAME {
  CRLV_FILE = 'CRLV_FILE',
  CNH_FILE = 'CNH_FILE',
  RG_FRONT_FILE = 'RG_FRONT_FILE',
  RG_BACK_FILE = 'RG_BACK_FILE',
}
